type NameFields = {
  full_name?: string;
  name?: string;
  first_name?: string;
  last_name?: string;
};

/** Display name from stored user fields — empty string when nothing is set. */
export function resolveProfileDisplayName(raw: NameFields): string {
  const fromParts = [raw.first_name, raw.last_name].filter(Boolean).join(' ').trim();
  return (raw.full_name || raw.name || fromParts || '').trim();
}

/** ui-avatars.com URL from a seed (name or email); empty when seed is blank. */
export function buildUiAvatarsUrl(
  seed: string,
  opts?: { background?: string; color?: string; size?: number }
): string {
  const s = seed.trim();
  if (!s) return '';
  const { background = 'F5A623', color = '000', size = 120 } = opts ?? {};
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(s)}&background=${background}&color=${color}&size=${size}&bold=true`;
}

export function resolveProfileAvatarUrl(
  raw: { avatar?: string; profile_picture?: string },
  seed: string,
  opts?: { background?: string; color?: string; size?: number }
): string {
  const stored = raw.avatar || raw.profile_picture;
  if (stored?.trim()) return stored.trim();
  return buildUiAvatarsUrl(seed, opts);
}
